import { render } from "./BtnClose.vue?vue&type=template&id=6e9c20b8&scoped=true"
const script = {}

import "./BtnClose.vue?vue&type=style&index=0&id=6e9c20b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9c20b8"]])

export default __exports__